import { render, staticRenderFns } from "./VoiceCallAlert.vue?vue&type=template&id=bbd5e8d0&scoped=true&"
import script from "./VoiceCallAlert.vue?vue&type=script&lang=js&"
export * from "./VoiceCallAlert.vue?vue&type=script&lang=js&"
import style0 from "./VoiceCallAlert.vue?vue&type=style&index=0&id=bbd5e8d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd5e8d0",
  null
  
)

export default component.exports